import type { GetStaticPaths, GetStaticProps } from "next";
import { useRouter } from "next/router";

import Loading from "lib/components/CenterLoading";
import type { NewsPostProps } from "lib/components/news/News";
import News from "lib/components/news/News";
import Page404 from "pages/404";

const Content = (attrbts: NewsPostProps) => {
  const router = useRouter();

  // Display loading until `getStaticProps()` finishes running, and populates the props.
  if (router.isFallback) {
    return <Loading />;
  }

  // If attributes are not populated, return an empty object.
  if ("error" in attrbts) {
    return <Page404 />;
  }

  return <News {...attrbts} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/items/blog/`
  );
  const posts = await res.json();

  const paths = posts.data.map((post: { slug: string }) => {
    return { params: { slug: post.slug } };
  });

  return {
    paths,
    fallback: true,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/items/blog?fields=slug,title,description,content,date_created,date_updated,media,user_created.first_name,user_created.last_name,user_created.title,user_created.avatar,user_updated.first_name,user_updated.last_name,user_updated.title,user_updated.avatar,category&filter[slug][_eq]=${params?.slug}`
  );
  const post = await res.json();

  if (post.data && post.data.length === 1) {
    return {
      props: post.data[0],
      revalidate: 10,
    };
  }
  return {
    props: { error: "Post not found" },
    revalidate: 10,
  };
};

export default Content;
